// @flow
import pure from './pure';

export default pure(null);
